module.exports = __webpack_public_path__ + "img/IMG_2248_L_Foamcore_MockedUp.33b6e4c3.jpg";